import { Tooltip as MuiTooltip } from '@mui/material';
import { TooltipProps } from './Tooltip.types';
import React, { FC, isValidElement } from 'react';

export const Tooltip: FC<TooltipProps> = (props) => {
  const { disabled = false, title, children, ...restProps } = props;

  const child = isValidElement(children) ? children : <span>{children}</span>;

  return (
    <MuiTooltip title={disabled ? '' : title} {...restProps}>
      {child}
    </MuiTooltip>
  );
};
